import { useGetPresentersList } from '@/hooks';
import { PresentersList } from '@/pages/AdvancedEditor/components/panels/avatars/PresentersList';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { PolotnoStoreActivePageKeys, useSetPolotnoActivePageState } from '@/pages/AdvancedEditor/hooks';
import { getAvatarPresenterFromPage } from '@/pages/AdvancedEditor/utils';
import { GenerateAvatar } from '@/pages/avatar';
import { ImageType, Presenter } from '@d-id/types';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useAddAvatarToPolotno } from '../utils/useAddAvatarToPolotno';
import { PresentersContainer } from '../PresentersContainer';

const MainTitle = styled.div`
    color: ${({ theme }) => theme.colors.secondary[700]};
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
`;

interface Props {
    setEditMode: (editMode: boolean) => void;
}
export const GeneratedSection = observer(({ setEditMode }: Props) => {
    const { store, setPresenterToDelete } = useAdvancedEditorContext();
    const setSelectedPresenter = useSetPolotnoActivePageState(PolotnoStoreActivePageKeys.selectedPresenter);
    const currentAvatar = getAvatarPresenterFromPage(store.activePage);

    const addAvatar = useAddAvatarToPolotno();
    const { data: presenters } = useGetPresentersList({ presenterType: ImageType.Dreams });

    function onPresenterClick(presenter: Presenter) {
        if (presenter.id === currentAvatar?.id) {
            setEditMode(true);
        }

        addAvatar(store.activePage, presenter);
        setSelectedPresenter(presenter.id);
    }

    const presentersToShow = useMemo(() => presenters?.filter(p => !p.id.includes('-removed_bg')), [presenters]);

    return (
        <>
            <GenerateAvatar from="advanced" />

            <MainTitle>AI Avatars</MainTitle>

            <PresentersContainer>
                <PresentersList
                    presenters={presentersToShow}
                    onClick={onPresenterClick}
                    onRemove={setPresenterToDelete}
                    selected={currentAvatar}
                />
            </PresentersContainer>
        </>
    );
});
